import { render, staticRenderFns } from "./CUInficationOrderTemp.vue?vue&type=template&id=79547689&scoped=true"
import script from "./CUInficationOrderTemp.vue?vue&type=script&lang=js"
export * from "./CUInficationOrderTemp.vue?vue&type=script&lang=js"
import style0 from "./CUInficationOrderTemp.vue?vue&type=style&index=0&id=79547689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79547689",
  null
  
)

export default component.exports